import { createApp } from 'vue'
import App from './App.vue'
import { loadFonts } from './plugins/webfontloader'

loadFonts()

const app = createApp(App)

// Vuetify
import vuetify from './plugins/vuetify'

// Axios
import api from "./plugins/api"
import VueAxios from 'vue-axios'

// Vuex
import store from './plugins/store'

// Moment
import moment from "moment-timezone";
app.config.globalProperties.$moment = moment;

// i18n Localization
import i18n from './i18n'

app.use(vuetify).use(VueAxios, api).use(store).use(i18n).mount('#__ETIX_WIDGET__')

import Hotjar from "@hotjar/browser";

const siteId = import.meta.env.VUE_APP_HOTJAR_SITE_ID;
const hotjarVersion = import.meta.env.VUE_APP_HOTJAR_VERSION;

Hotjar.init(siteId, hotjarVersion);